import { Card } from "@/src/components/cards";
import { closeDrawer, openDrawer } from "@/src/components/dialogs";
import {
  FamilyMemberRelationship,
  familyMemberRelationships,
} from "@/src/data/allTypes";

export async function openFamilyRelationshipPicker({
  current,
  onSelect,
}: {
  current: FamilyMemberRelationship | null | undefined;
  onSelect: (relationship: FamilyMemberRelationship) => void;
}) {
  await openDrawer({
    id: "familyRelationshipDrawer",
    title: "Membre de la famille",
    content: (
      <div className="c2 gap15">
        {Object.values(familyMemberRelationships).map((relationship) => {
          return (
            <Card
            key={relationship.id}
            className="empty"
              title={relationship.name}
              color={relationship.color}
              onClick={async () => {
                await onSelect(relationship.id);
                closeDrawer("familyRelationshipDrawer");
              }}
            />
          );
        })}
      </div>
    ),
  });
}
